// extracted by mini-css-extract-plugin
var _1 = "_adminsAdminDetailsForm-module__button-container";
var _2 = "_adminsAdminDetailsForm-module__button-subcontainer";
var _3 = "_adminsAdminDetailsForm-module__container";
var _4 = "_adminsAdminDetailsForm-module__form-container";
var _5 = "_adminsAdminDetailsForm-module__span-2";
export { _1 as "button-container", _2 as "button-subcontainer", _3 as "container", _4 as "form-container", _5 as "span-2" }
